module.exports = __webpack_public_path__ + "static/media/MSS_Web_logo.34ff72d7.png";